import { Injectable } from '@angular/core'
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'
import { ConfirmModalComponent } from '../components/confirm-modal/confirm-modal.component'

@Injectable({
    providedIn: 'root'
})
export class ConfirmModalService {
    constructor(
        private modalService: NgbModal,
        private translateService: TranslateService
    ) {}

    open(text: string, title?: string, params?: object, warn?: boolean, options?: NgbModalOptions): NgbModalRef {
        const modalText = this.translateService.instant(text, params || {})
        const modalTitle = title ? this.translateService.instant(title) : ''
        const modalRef = this.modalService.open(ConfirmModalComponent, options)
        modalRef.componentInstance.text = modalText
        modalRef.componentInstance.title = modalTitle
        if (warn) {
            modalRef.componentInstance.warn = true
        }
        return modalRef
    }

    openWarn(text: string, title?: string, params?: object, options?: NgbModalOptions): NgbModalRef {
        return this.open(text, title, params, true, options)
    }
}
